// extracted by mini-css-extract-plugin
export default {"suggestionsSection":"_1zcmtr","suggestionsTitle":"_q1c4n6"};